{% block postfinancecheckout_order_action_refund_by_amount %}
<sw-modal variant="small"
		  :title="$tc(`postfinancecheckout-order.modal.title.refund`)"
		  @modal-close="$emit('modal-close')">

	{% block postfinancecheckout_order_action_refund_amount_by_amount %}
		<mt-number-field
		 :max="refundableAmount"
		 :min="0"
		 v-model="refundAmount"
		 :label="$tc('postfinancecheckout-order.refund.refundAmount.label')"
		 :suffix="currency">
		</mt-number-field>
	{% endblock %}

	{% block postfinancecheckout_order_action_refund_confirm_button_by_amount %}
	<template #modal-footer>
		<mt-button variant="primary" @click="refundByAmount()">
			{{ $tc('postfinancecheckout-order.refundAction.confirmButton.text') }}
		</mt-button>
	</template>
	{% endblock %}

	<mt-loader v-if="isLoading"></mt-loader>
</sw-modal>
{% endblock %}
